export default "__VITE_ASSET__CEsCvSO5__"